// i18n area 'cluster' — locale fr-FR (task #171, onda 1): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/cluster.fr-FR.meta.json.
import type { enUS } from './cluster'

export const frFR: typeof enUS = {
  cluster: {
    // #233 — gli accessi di garanzia di un nodo (tradotto dall'italiano)
    nodeAccess: {
      title: 'Accès de garantie',
      subtitle: 'La porte de service du nœud : l’accès en lecture seule à mot de passe temporaire et le compte d’urgence avec le mot de passe du coffre',
      readOnlyTitle: 'Accès en lecture seule (trantor)',
      stateNone: 'fermé',
      stateGranted: 'ouvert',
      stateGrantedPending: 'accordé — en cours d’application sur le nœud',
      grantedBy: 'Accordé par',
      grantedAt: 'Accordé le',
      expiresAt: 'Expire le',
      reason: 'Motif',
      endedAt: 'Fermé',
      endedReason: {
        revoked: 'révoqué',
        expired: 'expiré (TTL)',
        reboot: 'redémarrage du nœud',
        failed: 'non appliqué (tâche échouée)'
      },
      grant: 'Accorder l’accès en lecture seule…',
      grantTitle: 'Accorder l’accès en lecture seule',
      grantSubmit: 'Accorder',
      grantError: 'L’octroi a été refusé',
      grantConfirm: 'TVirt génère un mot de passe temporaire pour l’utilisateur système « trantor » (lecture seule : journal et diagnostic, pas de sudo) et le définit sur le nœud via une tâche. Le mot de passe est affiché UNE seule fois, à la confirmation ; il cesse à l’échéance, à la révocation ou au prochain redémarrage du nœud.',
      reasonLabel: 'Motif',
      reasonHint: 'Pourquoi vous ouvrez la porte : cela figure dans l’octroi, dans l’audit et dans le journal',
      ttlLabel: 'Durée',
      ttlHours: '{n} h',
      revoke: 'Révoquer l’accès en lecture seule…',
      revokeTitle: 'Révoquer l’accès en lecture seule',
      revokeSubmit: 'Révoquer',
      revokeError: 'La révocation a été refusée',
      revokeConfirm: 'L’octroi prend fin immédiatement et une tâche verrouille à nouveau l’utilisateur « trantor » sur le nœud : le mot de passe temporaire cesse de fonctionner.',
      passwordTitle: 'Mot de passe en lecture seule',
      passwordOnce: 'Ce mot de passe est affiché UNE seule fois : copiez-le maintenant. Il n’est enregistré nulle part et ne pourra pas être relu — si vous le perdez, accordez à nouveau.',
      passwordUser: 'Utilisateur',
      passwordLabel: 'Mot de passe',
      passwordHint: 'Valable jusqu’au {until}, ou jusqu’au prochain redémarrage du nœud ; utilisable une fois la tâche d’octroi terminée. Accès : ssh trantor@<adresse du nœud>.',
      emergencyTitle: 'Dernier accès d’urgence (trantor-emergency)',
      lastLogin: '{time} via {via} depuis {from}',
      lastLoginNone: 'aucun observé',
      lastLoginVia: {
        ssh: 'ssh',
        console: 'console',
        sudo: 'sudo',
        unknown: 'inconnu'
      },
      emergencyHint: 'Le compte d’urgence « trantor-emergency » (sudo complet) est toujours activé avec le mot de passe généré à l’installation du nœud et conservé dans le coffre : TVirt ne le connaît pas, ne le fait pas tourner et ne le récupère pas. Chaque connexion est signalée ici et dans le journal des événements.'
    },
    nodeFirewall: {
      tab: 'Pare-feu',
      title: 'Pare-feu des nœuds',
      subtitle: 'La posture du ruleset nftables que chaque nœud s’applique à lui-même — l’unique pare-feu d’un nœud (firewalld est désactivé)',
      modeLabel: 'Posture',
      mode: {
        disabled: 'Désactivé — aucun ruleset sur les nœuds',
        permissive: 'Permissif — compte et journalise, ne rejette rien',
        enforced: 'Appliqué — seul le registre dérivé entre'
      },
      hint: {
        disabled: 'Comme aujourd’hui : les nœuds ne portent aucun ruleset. Passez en permissif pour LIRE ce qui serait rejeté avant que ce ne soit rejeté.',
        permissive: 'Chaque nœud applique son ruleset dérivé en policy accept : ce que le mode appliqué rejetterait est compté et journalisé (préfixe de journal « tvirt-node would-drop: »). Rien n’est bloqué.',
        enforced: 'Chaque nœud applique son ruleset dérivé en policy drop : ssh et l’API depuis partout, store / live migration / overlay / Ceph depuis les membres seulement, les listeners des services réseau depuis le réseau servi. Chaque bascule est un apply à confirmer — un nœud qui ne parvient pas à confirmer revient en arrière tout seul.'
      },
      confirmTitle: 'Appliquer le pare-feu des nœuds ?',
      confirmBody: 'Chaque nœud applique le ruleset à confirmer : il sonde son backend, le store et ssh à travers les nouvelles règles avant l’échéance et confirme — sinon il revient tout seul au ruleset précédent. Lisez d’abord les compteurs du mode permissif sur les nœuds.',
      confirmSubmit: 'Appliquer',
      confirmCancel: 'Annuler',
      lensTitle: 'Pare-feu du nœud',
      loadError: 'Impossible de charger la lentille du pare-feu du nœud',
      noReport: 'Aucun rapport de pare-feu de ce nœud, pas encore — le worker rend compte à son prochain passage',
      firewalldActive: 'firewalld tourne sur ce nœud : le pare-feu de nœud refuse de s’appliquer à côté de lui (masquez firewalld)',
      conditionUnconfirmed: 'Aucun ruleset confirmé, pas encore — le nœud est ouvert',
      conditionRolledBack: 'Le dernier apply est revenu en arrière — la même génération n’est pas retentée tant que le registre ne change pas ou que la posture n’est pas basculée à nouveau',
      lastError: 'Dernière erreur',
      posture: 'Posture',
      observedAt: 'Observé',
      desiredGeneration: 'Génération désirée',
      componentTitle: 'Composant de nœud',
      componentSubtitle: 'tvirt-node-firewall — applique au boot le ruleset confirmé, ramène tout seul en arrière un ruleset non confirmé',
      componentAbsent: 'Le composant n’a pas encore rendu compte',
      phase: 'Phase',
      phases: {
        none: 'Jamais appliqué',
        applied: 'Appliqué — en attente de confirmation',
        confirmed: 'Confirmé',
        rolledBack: 'Revenu en arrière'
      },
      generation: 'Génération',
      appliedAt: 'Appliqué le',
      confirmedAt: 'Confirmé le',
      deadline: 'Échéance du rollback',
      lastRollback: 'Dernier rollback',
      registryTitle: 'Registre dérivé',
      registrySubtitle: 'Les ports que ce nœud ouvre, par classe et origine — dérivés du cluster, jamais modifiés à la main',
      registryEmpty: 'Rien de dérivé — posture désactivée sans ruleset confirmé, ou aucun rapport pour l’instant',
      colClass: 'Classe',
      colPort: 'Port',
      colSource: 'Source',
      colOrigin: 'Origine',
      classes: {
        public: 'Publique',
        internode: 'Inter-nœud',
        tenant: 'Tenant'
      },
      sourceMembers: 'les membres seulement',
      sourceAnywhere: 'partout',
      sourceBridge: 'sur {iface}'
    },
    derivationDerived: 'dérivé',
    derivationDiverged: 'divergent',
    derivationDerivedTip: 'Le document réseau est DÉRIVÉ de la fabric {fabric} et coïncide encore avec le rendu sur les entrées courantes — cliquez pour le plan de dérivation.',
    derivationDivergedTip: 'La dérivation de la fabric {fabric} a changé après le dernier apply (fabric, câblage, rôles ou références) — cliquez pour le diff en attente.',
    derivationRetiring: {
      one: '{n} adresse en drainage',
      many: '{n} adresses en drainage',
      other: '{n} adresses en drainage'
    },
    standaloneHint: "Ce nœud n'a pas de cluster : il n'a pas encore été installé. Les clusters se créent OU se joignent à l'installation — le token généré depuis la table Serveurs d'un membre est donné en pâture à l'installer (dev: db:init-cluster / db:init-join).",
    reducedHint: 'Vos permissions couvrent un scope, pas le cluster entier : l’inventaire de la flotte — nœuds, paramètres et périphériques — n’est visible que par les administrateurs du cluster.',
    phaseReady: 'Prêt',
    phaseForming: 'En formation',
    storeMembers: 'Membres du store',
    watermark: 'Seuil de convergence',
    configGeneration: 'Génération de config',
    converged: 'aligné',
    behind: 'en retard — {m} / {n}',
    revision: 'Révision',
    rolesTitle: 'Rôles réseau',
    rolesSubtitle: 'Adresses par membre pour chaque classe de trafic — la connectivité elle-même vit dans le réseau host',
    roleManagement: 'Management',
    roleLiveMigration: 'Live Migration',
    roleInherited: 'hérite du management',
    settingsTitle: 'Paramètres',
    settingsSubtitle: "Policy de sécurité à l'échelle du cluster — évaluée par chaque nœud depuis sa réplique locale",
    taskRetentionTitle: 'Rétention des tasks',
    taskRetentionSubtitle: "GC unifié pour toutes les tasks — les tasks terminées au-delà de l'âge ou du plafond sont collectées, jamais celles en cours",
    taskRetentionMaxAge: 'Âge maximal (jours)',
    taskRetentionMaxCount: 'Nombre maximal de tasks',
    eventRetentionTitle: 'Rétention des événements',
    eventRetentionSubtitle: "Le GC du journal — une politique indépendante de celle des tâches : la tâche est une file, l'événement est de la mémoire",
    eventRetentionMaxAge: 'Âge maximal (jours)',
    eventRetentionMaxCount: "Nombre maximal d'événements",
    spaceThresholdsTitle: "Seuils d'espace",
    spaceThresholdsSubtitle: 'Quand un stockage qui se remplit entre dans le journal (et dans les notifications)',
    spaceLowPct: 'Avertissement à partir de (% utilisé)',
    spaceCriticalPct: 'Critique à partir de (% utilisé)',
    spaceOrderError: "Le critique ne peut pas être sous l'avertissement",
    spaceThresholdsHint: "Seules les entrées se configurent : la sortie est dérivée par le moteur, 5 points sous chaque seuil, pour qu'un stockage posé sur la ligne ne devienne jamais un métronome",
    failoverReserveTitle: 'Réserve de failover',
    failoverReserveSubtitle: 'Admission control N+1 — RAM gardée libre pour que le cluster puisse redémarrer sa charge après la perte de nœuds',
    failoverReserveTolerate: 'Nœuds dont tolérer la perte',
    failoverReserveOff: "0 — réserve désactivée : aucun démarrage n'est jamais refusé pour capacité de failover",
    failoverReserveOn: 'Un démarrage qui entamerait la réserve est refusé avec un 412 qui explique les chiffres',
    networkShapingTitle: 'Équité de bande passante',
    networkShapingSubtitle: 'Les trois poids par typologie de l\'arbre de shaping par uplink — ils n\'agissent qu\'en cas de contention',
    networkShapingRest: 'Poids du reste (plan de contrôle, storage, réplicas)',
    networkShapingOverlay: 'Poids des réseaux overlay',
    networkShapingLiveMigration: 'Poids de la live migration',
    networkShapingHint: 'Part garantie = poids / somme des trois (par défaut 300 / 100 / 200, chacun de 1 à 10000) ; sur un lien libre chaque classe peut prendre toute la bande passante',
    debugModeTitle: 'Mode debug',
    debugModeSubtitle:
      'Erreurs détaillées dans les alertes génériques de la GUI — pour voir la vraie cause quand une action « échouée » a en fait réussi',
    debugModeLabel: 'Mode debug activé',
    debugModeOn: "Les alertes d'erreur génériques ajoutent la cause sous-jacente — détails internes visibles à chaque opérateur",
    debugModeOffHint: "Désactivé — les alertes d'erreur génériques restent génériques, sans détails internes",
    nodeDetailsAction: 'Détails du nœud',
    node: {
      docTitle: 'Nœud',
      notFound: 'Nœud introuvable',
      tabOverview: "Vue d'ensemble",
      tabStats: 'Statistiques',
      tabNetwork: 'Réseau',
      tabSettings: 'Paramètres locaux',
      identityTitle: 'Identité',
      heartbeatTitle: 'Heartbeat',
      ysqlPort: 'Port YSQL',
      revision: 'Révision de config',
      versionsTitle: 'Versions observées',
      heartbeatSubtitle: 'Le dernier état que le nœud a rapporté sur lui-même',
      cpuTitle: 'CPU',
      cpuModelTitle: 'Modèle de CPU',
      memoryTitle: 'Mémoire',
      hugePagesTitle: 'Pages énormes',
      hugePagesPool: '{size} : {free} libres sur {total}',
      hugePagesNone: 'Aucune réserve',
      hugePagesNoneHint: 'Le nœud n\'a aucune page énorme réservée : les VM qui en demandent ne peuvent pas démarrer ici. La réserve se déclare sur le nœud, avec les paramètres hugepagesz et hugepages du noyau ou en écrivant nr_hugepages.',
      usageTitle: 'Utilisation courante',
      usageMem: 'RAM {n} MiB',
      usageUnknown: 'non observé — aucun échantillon frais',
      statsNoData: "Aucune donnée sur l'intervalle sélectionné — les séries du nœud sont échantillonnées par le nœud lui-même et servies en local.",
      observedTitle: 'État observé',
      observedSubtitle: 'Services et assets locaux au nœud, tels que le worker les voit'
    },
    editRolesTitle: 'Modifier les rôles réseau',
    memberNode: 'Nœud',
    memberIp: 'Adresse IP',
    addMember: 'Ajouter un membre',
    lmInherit: 'Utiliser les adresses de management',
    roleIpHint: "Ajouter et retirer des membres est libre ; changer sur place l'IP d'un membre existant est refusé — le flux de migration IP arrive dans un round ultérieur.",
    roleError: 'Impossible de mettre à jour les rôles',
    nodesTitle: 'Nœuds',
    addNodeTitle: 'Ajouter un nœud au cluster',
    addNode: 'Ajouter un nœud',
    addNodeError: 'Impossible de pré-enregistrer le nœud',
    nodeName: 'Nom du nœud',
    nodeNameHint: "doit correspondre au nom choisi à l'installation",
    nodeIp: 'IP de management',
    colName: 'Nom',
    colPhase: 'Phase',
    colServices: 'Services',
    colWatermark: 'Watermark',
    colLastSeen: 'Dernier contact',
    colUps: 'UPS',
    upsCordonChip: 'cordon UPS',
    upsCordonTip: 'Le nœud s’est condamné sur les faits de son onduleur ({time}) : il lève le cordon de lui-même dès que le secteur est stable et la batterie rechargée',
    upsUnreachable: 'UPS injoignable',
    upsOnBattery: 'Sur batterie',
    upsOnLine: 'Sur secteur',
    upsLowBattery: 'batterie faible',
    upsNoEstimateChip: 'autonomie non estimée',
    upsNoEstimateTip: 'L’onduleur ne publie pas d’estimation d’autonomie : le nœud n’est condamné que par le drapeau LB (batterie faible) de l’onduleur — réglez battery.runtime.low / LB sur l’onduleur',
    upsLaneTip: 'Voie d’arrêt UPS depuis {since} : condamné par {by}',
    upsUnit: 'unité',
    upsStatus: 'état NUT',
    upsLoad: 'charge',
    upsOnBatterySince: 'sur batterie depuis',
    upsOnLineSince: 'sur secteur depuis',
    upsError: 'erreur',
    upsObservedAt: 'observé',
    upsNone: 'aucune unité UPS ne dessert ce nœud',
    upsBy: {
      runtime: 'autonomie sous le seuil',
      lowBattery: 'drapeau LB de l’onduleur',
    },
    upsLane: {
      evacuate: 'évacuation',
      local: 'arrêt sur place',
    },
    upsPhase: {
      draining: 'drain',
      stoppingGuests: 'arrêt des invités',
      stoppingServices: 'arrêt des services',
      poweredOff: 'éteint',
    },
    upsTitle: 'UPS (NUT)',
    upsSubtitle: 'Unités UPS et seuils : nœud condamné à autonomie ≤ seuil ou sur drapeau LB (toujours honoré), reprise avec hystérésis',
    upsRuntimeThreshold: 'Seuil d’autonomie (s)',
    upsRuntimeThresholdHint: 'Sur batterie, avec autonomie estimée ≤ seuil le nœud s’arrête en ordre (défaut 300)',
    upsResumeStable: 'Secteur stable pendant (s)',
    upsResumeStableHint: 'Reprise seulement avec un secteur continu depuis au moins tant de secondes (défaut 60)',
    upsResumeCharge: 'Charge minimale à la reprise (%)',
    upsResumeChargeHint: 'Et batterie rechargée au moins à ce pourcentage (défaut 25)',
    upsPolicyNote: 'Le drapeau LB (batterie faible) de l’onduleur condamne toujours et ne se désactive pas ; il n’existe pas de seuil sur le temps passé sur batterie. Chaque unité peut surcharger les trois nombres.',
    upsUnitNew: 'nouvelle unité',
    upsUnitSelectors: '{n} sélecteur(s) par tag (CLI seulement)',
    upsUnitName: 'Nom de l’unité',
    upsUnitMode: 'Mode',
    upsModeExternal: 'externe (upsd d’autrui)',
    upsModeManaged: 'gérée (onduleur relié à un nœud)',
    upsUnitUpsname: 'Nom NUT (upsname)',
    upsUnitHost: 'Hôte upsd',
    upsUnitAttachedNode: 'Nœud relié',
    upsUnitDriver: 'Pilote NUT',
    upsUnitDriverHint: 'usbhid-ups, nutdrv_qx, snmp-ups, …',
    upsUnitDevice: 'Périphérique du pilote',
    upsUnitDeviceHint: 'la ligne port= de ups.conf : vide = auto',
    upsUnitPort: 'Port upsd',
    upsUnitServedNodes: 'Nœuds desservis',
    upsUnitServedNodesHint: 'noms des nœuds séparés par des virgules (les sélecteurs par tag passent par la CLI)',
    upsUnitOverrideHint: 'vide = défaut du cluster',
    upsUnitAdd: 'Ajouter une unité',
    unreachableSince: 'Injoignable — dernier heartbeat {time}',
    overlaysChip: 'overlays',
    overlaysBehind: "Le dataplane overlay n'a pas encore réalisé la configuration overlay courante",
    overlaysError: 'Dernière passe de réconciliation overlay échouée : {error}',
    storeChip: 'store',
    phase: {
      'pending-join': 'En attente de join',
      'joining': 'Join en cours',
      'member': 'Membre'
    },
    tokenTitle: 'Join token',
    tokenOnce: 'Affiché seulement maintenant — copiez-le tout de suite, il ne sera plus jamais lisible',
    copy: 'Copier',
    copied: 'Copié',
    close: 'Fermer',
    revokeTitle: 'Révoquer le pré-enregistrement',
    revoke: 'Révoquer',
    revokeError: "Impossible de révoquer l'enregistrement",
    promote: 'Promouvoir en store member',
    demote: 'Retirer le rôle store-member',
    troubleshoot: 'Dépannage',
    promoteTitle: 'Promouvoir en store member',
    demoteTitle: 'Retirer le rôle store-member',
    promoteHint: 'Le nœud entre dans le quorum des masters YugabyteDB. La vraie HA exige trois store members.',
    demoteHint: 'Le nœud quitte le quorum des masters et arrête ses services store.',
    storeError: 'La modification du store-member a été refusée',
    attest: 'Attester éteint…',
    attestTitle: 'Attester le nœud éteint',
    attestSubmit: 'Attester éteint',
    attestConfirm: 'Vous déclarez ce nœud éteint, à vos risques : attester un nœud en réalité vivant risque des VM en double exécution. Ses tasks sont mises en échec et les authorities de ses VM deviennent transférables.',
    attestError: "L'attestation a été refusée",
    attestedChip: 'attesté éteint',
    maintenanceChip: 'maintenance',
    guestToolsChip: 'TVirt Guest Tools (asset ISO local au nœud)',
    maintenanceEnter: 'Activer la maintenance',
    maintenanceExit: 'Désactiver la maintenance',
    maintenanceEnterTitle: 'Activer la maintenance',
    maintenanceExitTitle: 'Désactiver la maintenance',
    maintenanceEnterSubmit: 'Activer la maintenance',
    maintenanceExitSubmit: 'Désactiver la maintenance',
    maintenanceEnterConfirm: "Le nœud est mis en cordon et vidé : les services réseau et les instances App dont il détient l'authority sont transférés (les instances à froid : arrêtées et fauchées ici, recréées sur le nœud cible — indisponibilité), les VM allumées sont migrées à chaud quand c'est possible et arrêtées proprement sinon, les tâches en cours se terminent, le nouveau travail attend et les VM arrêtées perdent leur authority — Proximity les replace au prochain démarrage. Rien ne revient de soi-même à la fin de la maintenance.",
    maintenanceExitConfirm: "Le nœud recommence à travailler et Proximity le considère à nouveau pour le placement. Les VM ne reviennent que lorsqu'elles sont démarrées.",
    maintenanceError: 'La demande de maintenance a été refusée',
    maintenancePlanTitle: "Plan d'évacuation",
    maintenancePlanLoading: "Calcul du plan d'évacuation…",
    maintenancePlanError: "Impossible de charger le plan d'évacuation — le drain migrera quand même là où c'est possible et arrêtera le reste.",
    maintenancePlanEmpty: 'Rien à évacuer sur ce nœud — aucun service réseau actif, aucune instance App voulue en exécution, aucune VM allumée.',
    maintenancePlanSummary: "{migrate} objets migreront (VM, services réseau, instances App), {stop} s'arrêteront ou resteront où ils sont.",
    maintenancePlanReserve_ok: 'Réserve de failover après le vidage : intacte — il reste {headroom} GiB démarrables en tolérant la perte de {n} nœud(s).',
    maintenancePlanReserve_eroded: 'Réserve de failover après le vidage : presque consommée — il ne reste que {headroom} GiB des {reserve} GiB gardés libres pour {n} panne(s) de nœud.',
    maintenancePlanReserve_exhausted: 'Réserve de failover après le vidage : ÉPUISÉE — il manque {headroom} GiB des {reserve} GiB nécessaires pour tolérer {n} panne(s) de nœud. Tant que ce nœud est absent, les nouveaux démarrages de VM seront refusés.',
    maintenancePlanReserve_unknown: "Réserve de failover après le vidage : non calculable — aucun nœud restant n'a déclaré sa mémoire.",
    maintenancePlanReserveHugePages: 'Pages énormes de {size} après le vidage — libres : {free} sur {capacity}, requises en réserve : {reserve}.',
    maintenancePlanActionMigrate: 'migre',
    maintenancePlanActionMigrateWarning: 'migre (règle soft violée)',
    maintenancePlanActionStop: "s'arrête",
    maintenancePlanActionBlocked: 'bloquée',
    maintenancePlanKindVm: 'VM',
    maintenancePlanKindNetsvc: 'service réseau',
    maintenancePlanKindApp: 'instance App',
    maintenancePlanColdMove: "Déplacement à froid : le pod est arrêté et fauché ici et recréé sur le nœud cible par son worker — indisponibilité jusqu'au prochain pass du worker cible.",
    caFingerprint: 'Fingerprint de la CA du cluster',
    staleChip: 'pas à jour',
    troubleshootTitle: 'Dépannage du store',
    restartStore: 'Redémarrer les services store',
    restartHint: 'Si le store fait des caprices, redémarrez ses services. Avancé — à utiliser avec prudence.',
    restartQueued: "Task de redémarrage en file d'attente",
    restartError: 'Impossible de redémarrer les services',
    svcActive: 'actif',
    svcWanted: 'voulu, non actif',
    svcStopped: 'arrêté',
    noServices: 'Aucun service rapporté'
  },
  clusterDevices: {
    gpusTitle: 'GPU / PCIe',
    gpusSubtitle: "L'inventaire GPU du cluster entier regroupé par modèle — les cartes observées par nœud, avec les enregistrements marqués et leurs tags",
    usbTitle: 'Ressources USB',
    usbSubtitle: "L'inventaire USB du cluster entier regroupé par modèle — les périphériques observés par nœud, avec les enregistrements des deux modèles (par périphérique, par port) et leurs tags",
    markedChip: '{n} utilisables par TVirt',
    orphanChipGpu: '{n} orphelines',
    orphanChipUsb: '{n} orphelins',
    colNode: 'Nœud',
    colRegistration: 'Enregistrement',
    noRegsHint: 'Aucun enregistrement — le périphérique se marque "utilisable par TVirt" depuis le dialog du nœud (Nœuds › nœud › Paramètres).',
    colDevice: 'Périphérique',
    colObserved: 'Observés',
    colRegs: 'Enregistrements',
    regsNone: 'aucun',
    colPci: 'Adresse PCIe',
    colIdentity: 'Identité / port',
    colClasses: 'Classes (tags)',
    colActions: 'Actions',
    manageOnNode: 'Gérer sur le nœud {node} (le marquage vit dans le dialog du nœud)',
    introTitle: "L'inventaire cluster des périphériques USB et PCIe utilisables par TVirt©.",
    introStep1: '1. Les nœuds découvrent seuls leurs GPU et leurs périphériques USB (recensement dans le heartbeat).',
    introStep2: '2. Un périphérique se marque "utilisable par TVirt" depuis le dialog du NŒUD (Nœuds › nœud › Paramètres) — le marquage le lie à vfio et l\'enregistre ici.',
    introStep3: '3. Ici vous donnez aux enregistrements leurs CLASSES via tags (ex. gpu_class=compute) : les exigences des VM demanderont une classe, et le scheduler choisira un nœud avec un périphérique libre compatible.',
    colMode: 'Mode',
    colState: 'État',
    colNotes: 'Notes',
    colTags: 'Tags',
    modeDevice: 'par périphérique',
    modePort: 'par port',
    usable: 'utilisable',
    orphanGpu: 'orpheline',
    orphanUsb: 'orphelin',
    hubChip: 'hub',
    orphanPortsTitle: 'Enregistrements par port sans périphérique branché — rebranchez un périphérique ou démarquez-les depuis le nœud',
    gpusEmpty: 'Aucune GPU encore observée sur aucun nœud',
    usbEmpty: 'Aucun périphérique USB encore observé sur aucun nœud'
  },
  settings: {
    passwordMinLength: 'Longueur minimale du mot de passe',
    sessionIdle: "Timeout d'inactivité de session (minutes)",
    lockoutThreshold: 'Verrouillage après tentatives échouées',
    lockoutDuration: 'Durée du verrouillage (minutes)',
    keyboardLayout: 'Layout clavier',
    keyboardLayoutHint: 'ex. it, en-us — vide pour le default QEMU',
    syslogEndpoint: 'Endpoint syslog',
    syslogEndpointHint: 'host:port — vide pour désactiver le transfert',
    syslogTls: 'TLS',
    maxQueued: "Maximum de tasks en file d'attente",
    concurrency: 'Concurrence du worker',
    concurrencyHint: 'Appliquée à la volée par le worker',
    notesTitle: 'Notes',
    save: 'Enregistrer',
    saved: 'Paramètres enregistrés',
    saveError: "Impossible d'enregistrer les paramètres"
  },
  localSettings: {
    derivedChip: 'dérivé',
    derivedTip: 'Ce device APPARTIENT à la dérivation de la fabric (H2) : l\'éditeur refuse d\'y toucher — modifiez la fabric (ou le câblage) et réappliquez, ou reprenez-le ci-dessous.',
    takeOwnership: 'Prendre possession',
    takeOwnershipTitle: 'Prendre possession (take-ownership)',
    takeOwnershipConfirm: '{name} quitte le bloc fabric et redevient un device MANUEL gouverné par cet éditeur. Le nœud devient divergent, et le prochain apply de la dérivation le refusera (manualConflict) jusqu\'à ce que vous le renommiez ou le retiriez — ou corrigiez la fabric.',
    nodeSettingsTitle: 'Paramètres du nœud',
    nodeSettingsSubtitle: 'Ce que ce nœud applique — file des tasks, console, transfert des logs — plus ses tags et ses notes',
    baseTitle: 'Réserves host (TVirt Proximity)',
    baseSubtitle: "CPU et RAM réservés au système d'exploitation de l'host — les inputs de la capacité empirique avec laquelle Proximity place les VM",
    baseMemory: 'RAM de base (MiB)',
    baseMemoryHint: 'Total observé : {total} MiB. Utilisable pour les VM = total − base − RAM des VM allumées placées ici.',
    baseMemoryHintNoTotal: 'Utilisable pour les VM = total observé − base − RAM des VM allumées placées ici.',
    baseCpu: 'Cores CPU de base',
    baseCpuHint: "CPU logiques observés : {total}. Utilisés seulement comme poids de ranking — l'overcommit de vCPU est normal.",
    baseCpuHintNoTotal: "Utilisés seulement comme poids de ranking — l'overcommit de vCPU est normal.",
    baseHint: "La RAM est le gate strict d'admission : une VM qui ne tient pas dans la RAM utilisable est refusée avec une erreur parlante. Augmentez la base sur les hosts qui hébergent des membres du store ou des démons Ceph.",
    placementTitle: 'Placement physique',
    placementSubtitle: "Où ce serveur se trouve physiquement — déclaré une fois, quoi qu'il serve",
    placementHint: 'Le placement pilote la hiérarchie CRUSH de chaque cluster Ceph avec un OSD sur ce serveur : enregistrer un changement réaligne leurs maps via task (host → rack → … → root). Les déclarations partielles sont légales — les niveaux vides se replient. Les noms sont partagés sur toute la map : deux serveurs dans le même rack déclarent le même nom de rack.',
    placementNameInvalid: 'Nom DNS-safe (minuscules, chiffres, tirets)',
    placementEmpty: 'Vide = non déclaré',
    placementLevel: {
      chassis: 'Châssis',
      rack: 'Rack',
      row: 'Rangée',
      pdu: 'PDU',
      pod: 'Pod',
      room: 'Salle',
      datacenter: 'Datacenter',
      zone: 'Zone',
      region: 'Région'
    },
    cablingTitle: 'Câblage',
    cablingSubtitle: 'À quel port du switch chaque interface est branchée — la déclaration vit sur le nœud (Annex O.9)',
    cablingHint: "Un câble par NIC, un câble par port sur toute la flotte (l'API refuse en nommant le titulaire). Câbler vers un port membre d'un LAGG est légal — c'est le cas bond : la dérivation future le rendra comme LACP.",
    cablingInterface: 'Interface',
    cablingNotCabled: '— non câblée —',
    cablingNoInterfaces: 'Aucune interface réseau observée',
    disksTitle: 'Disques',
    disksSubtitle: "Périphériques bloc observés — un balayage par passe de réconciliation ; marquez ici les disques utilisables comme OSD Ceph (N.15 : l'éligibilité est explicite)",
    colDataDisk: 'Disque de données',
    dataDisksHint: "Cocher un périphérique le déclare utilisable comme OSD ; le numéro de série est son pin d'identité — copié depuis le hardware quand le disque le rapporte, frappé (tvirt-…) sinon. Le dialog d'enregistrement Ceph n'offre que les disques déclarés.",
    diskDeclaredSerial: 'déclaré',
    diskNotObserved: 'déclaré mais non observé — raccrochez le device ou décochez-le',
    noDisks: 'Aucun périphérique bloc encore observé',
    colSerial: 'N° de série',
    colModel: 'Modèle',
    colSize: 'Taille (GiB)',
    colDiskType: 'Type',
    colInUse: 'En usage',
    colObservedAt: 'Observé',
    diskInUse: 'en usage',
    diskFree: 'libre',
    diskMounted: 'monté',
    diskPartitions: 'partitions',
    passthroughTitle: 'Périphériques passthrough',
    passthroughSubtitle: "GPU et périphériques USB observés — marquez ici ce que TVirt peut passer aux VM ; le marquage enregistre l'identité du périphérique (round U1+G1)",
    passthroughHint: "Le marquage enregistre le périphérique (un id stable — la cible des tags et des exigences de classe). Une GPU marquée a son groupe IOMMU ENTIER lié à vfio-pci d'un bloc — elle quitte immédiatement l'host ; le démarquage raccroche le driver natif. Pour l'USB les deux modèles ratifiés existent : par périphérique (vendor+produit, où qu'il soit branché) et par port physique (la VM reçoit tout ce qui y est enfiché). L'USB ne fait pas de bind au marquage — l'attach a lieu au runtime de la VM.",
    passthroughGpusTitle: 'GPU / PCIe',
    passthroughUsbTitle: 'USB',
    colUsable: 'Utilisable par TVirt',
    colGpu: 'GPU',
    colPciAddress: 'Adresse PCI',
    colDriver: 'Driver',
    colVerdict: 'Verdict',
    gpuEligible: 'Éligible',
    gpuIneligible: 'Non éligible',
    gpuReason: {
      'no-iommu': "IOMMU non actif sur l'host",
      'group-spans-slots': "groupe IOMMU non isolé : il s'étend sur d'autres slots",
      'multiple-display': "groupe IOMMU non isolé : plus d'une fonction vidéo",
      'foreign-function': 'groupe IOMMU non isolé : il contient une fonction étrangère'
    },
    vfioNotReady: "L'IOMMU n'est pas actif sur cet host : aucune GPU n'est éligible tant que la plateforme host ne l'active pas (ISO OEM) — TVirt ne retouche jamais les kernel args au runtime.",
    vfioMissingKernelArg: "L'IOMMU n'est pas actif sur cet host : le firmware rapporte VT-d/AMD-Vi (table ACPI DMAR/IVRS présente) mais le kernel arg manque — ajoutez intel_iommu=on (Intel) ou retirez amd_iommu=off (AMD) de la command line du kernel et redémarrez. TVirt ne retouche jamais les kernel args au runtime.",
    vfioFirmwareDisabled: "L'IOMMU n'est pas actif sur cet host : VT-d/AMD-Vi est désactivé dans le firmware (aucune table ACPI DMAR/IVRS) ou bien le CPU ne le supporte pas — activez-le dans le setup du firmware, aucun kernel arg ne peut l'allumer. TVirt ne retouche jamais l'host au runtime.",
    gpuBindError: 'Bind vfio-pci échoué sur {address} : {error}',
    firewallBridgesTitle: 'Pare-feu sur bridges non gérés',
    firewallBridgesSubtitle: "Les bridges construits à la main sur ce nœud dont le setup consent aux chains pare-feu rendues par TVirt sur les NIC d'invité attachées",
    firewallBridgesHint: "TVirt ne touche jamais au bridge étranger — la chain s'ancre sur le tap/veth, qui est toujours à TVirt. La liste est un gate de consentement : default-deny et anti-spoof peuvent casser ce qu'un setup manuel attend, donc une NIC avec pare-feu sur un bridge non géré NON listé ici est refusée avec une erreur parlante.",
    firewallBridgesEmpty: 'Aucun bridge non géré ne consent aux chains pare-feu rendues par TVirt sur ce nœud.',
    firewallBridgeAdd: 'Ajouter un bridge',
    firewallBridgeInvalid: "Pas un nom d'interface Linux (1-15 caractères, sans slash ni espace)",
    firewallBridgeDuplicate: 'Nom déjà listé',
    colMarkDevice: 'Par périphérique',
    colMarkPort: 'Par port',
    usbHub: 'hub',
    colUsbId: 'Vendor:Product',
    colPort: 'Port',
    passthroughOrphan: 'orphelin — enregistré mais plus détecté : rebranchez-le ou démarquez-le',
    noGpus: 'Aucune GPU encore observée',
    noUsb: 'Aucun périphérique USB encore observé',
    networkGeneration: 'Génération de réseau',
    applied: 'Appliquée',
    converged: 'aligné',
    behind: 'en retard — {m} / {n}',
    notConfigured: 'non configuré',
    rollbackBody: 'Application de la génération {gen} échouée : {error}',
    rolledBackChip: 'rollback effectué',
    nicsTitle: 'NIC',
    nicsSubtitle:
      "Le registre des NIC gérées — l'enregistrement EST la déclaration de gestion : une NIC enregistrée sans configuration n'est pas touchée (clear-if la déclare explicitement propre), un périphérique non enregistré n'est jamais touché",
    addNic: 'Enregistrer une NIC',
    addNicTitle: 'Enregistrer une NIC (add-nic)',
    delNic: 'Terminer la gestion',
    delNicTitle: 'Terminer la gestion (del-nic)',
    delNicConfirm:
      "La gestion de {name} se termine : l'entrée du registre et sa configuration sont supprimées et le profil TVirt retiré — le périphérique reste tel que Linux l'a.",
    nicName: 'Nom du périphérique',
    nicMac: 'Adresse MAC permanente',
    nicMacHint: "le MAC hardware permanent — l'identité stable fixée par le TVirt Server Installer",
    colObserved: 'Observée',
    nicObserved: 'observée',
    nicNotObserved: 'non observée',
    nicMacMismatch: 'MAC divergent — observé {mac}',
    noNics: 'Aucune NIC enregistrée — enregistrez un périphérique pour commencer à le gérer',
    noManagedDevices: "Aucun périphérique géré — enregistrez d'abord une NIC, tout se construit sur le registre",
    inventoryTitle: 'Périphériques observés',
    inventorySubtitle: 'Rafraîchis à chaque passe de réconciliation par le worker du nœud — la validation vérifie les noms des périphériques sur cet inventaire',
    colDevice: 'Périphérique',
    colType: 'Type',
    colMac: 'MAC',
    colLink: 'Link',
    colSpeed: 'Débit',
    colTopology: 'Topologie',
    colMtu: 'MTU',
    colAddresses: 'Adresses',
    linkUp: 'up',
    linkDown: 'down',
    lacpDegraded: 'LACP n’agrège pas',
    noInventory: "Aucun périphérique rapporté jusqu'ici",
    interfacesTitle: 'Interfaces',
    interfacesSubtitle:
      'Configuration L3 des NIC enregistrées et des périphériques logiques déclarés — set-if remplace le bloc entier, edit-if retouche les propriétés, clear-if le vide (propreté explicite)',
    colConfig: 'Configuration désirée',
    clean: 'propre',
    setIf: "Modifier l'adressage",
    setIfTitle: "Modifier l'adressage (set-if)",
    editIf: 'Modifier les propriétés',
    editIfTitle: 'Modifier les propriétés (edit-if)',
    clearIf: 'Vider la configuration',
    clearIfTitle: 'Vider la configuration (clear-if)',
    clearIfConfirm: "La configuration de l'interface est vidée. Une interface propre est le prérequis pour l'asservir comme membre d'un bond/bridge ou parent de VLAN.",
    ip4Mode: 'Mode IPv4',
    ip6Mode: 'Mode IPv6',
    modeUnconfigured: 'Non configurée',
    modeStatic: 'Statique',
    modeDhcp: 'DHCP',
    ip4Addresses: 'Adresses IPv4',
    ip6Addresses: 'Adresses IPv6',
    addressesHint: 'CIDR, séparées par des virgules',
    gw4: 'Gateway IPv4',
    gw6: 'Gateway IPv6',
    dns: 'Serveurs DNS',
    dnsHint: 'séparés par des virgules — vide remet le DNS à zéro (set-if remplace le bloc)',
    routes4: 'Routes statiques IPv4',
    routes6: 'Routes statiques IPv6',
    routeTo: 'Destination (CIDR)',
    routeVia: 'Via',
    addRoute: 'Ajouter une route',
    routesChip: 'routes',
    mtu: 'MTU',
    mtuHint: 'vide = default du driver',
    vlansTitle: 'VLAN',
    addVlan: 'Ajouter un VLAN',
    addVlanTitle: 'Ajouter un VLAN (add-vlan)',
    delVlanTitle: 'Supprimer le VLAN (del-vlan)',
    vlanParent: 'Interface parent',
    vlanId: 'ID VLAN',
    vlanPreview: 'Nom du périphérique',
    colParent: 'Parent',
    colVlanId: 'ID',
    noVlans: 'Aucun VLAN déclaré',
    bondsTitle: 'Bonds',
    addBond: 'Ajouter un bond',
    addBondTitle: 'Ajouter un bond (add-bond)',
    editBondTitle: 'Modifier le bond',
    editBond: 'Enregistrer le bond',
    delBondTitle: 'Supprimer le bond (del-bond)',
    bondName: 'Nom du bond',
    members: 'Membres',
    membersHint: 'les membres doivent être des interfaces propres (sans configuration L3)',
    bondMode: 'Mode',
    modeActiveBackup: 'active-backup',
    modeLacp: 'LACP (802.3ad)',
    miimon: 'miimon (ms)',
    primary: 'Membre primaire',
    rate: 'Rate LACP',
    hash: 'Politique de hash en transmission',
    colMembers: 'Membres',
    colMode: 'Mode',
    noBonds: 'Aucun bond déclaré',
    bridgesTitle: 'Bridges',
    addBridge: 'Ajouter un bridge',
    addBridgeTitle: 'Ajouter un bridge (add-bridge)',
    editBridgeTitle: 'Modifier le bridge',
    editBridge: 'Enregistrer le bridge',
    delBridgeTitle: 'Supprimer le bridge (del-bridge)',
    bridgeName: 'Nom du bridge',
    stp: 'STP',
    stpOn: 'STP actif',
    stpOff: 'STP éteint',
    colStp: 'STP',
    noBridges: 'Aucun bridge déclaré',
    hostnameTitle: 'Hostname',
    hostname: 'Hostname',
    setHostname: 'Définir le hostname',
    setHostnameTitle: 'Définir le hostname (set-hostname)',
    hostnameHint: "Identité OS seulement — le nom du nœud dans le cluster n'est pas touché",
    notSet: 'non défini',
    staticHostsTitle: 'Entrées host statiques',
    addStaticHost: 'Ajouter une entrée',
    addStaticHostTitle: 'Ajouter une entrée host statique',
    delStaticHostTitle: "Supprimer l'entrée host statique",
    hostIp: 'Adresse IP',
    hostNames: 'Noms',
    hostNamesHint: 'séparés par des virgules ou des espaces',
    colIp: 'IP',
    colNames: 'Noms',
    noStaticHosts: 'Aucune entrée host statique',
    delConfirm: 'Retrait de {name} du document désiré — le worker du nœud converge avec un checkpoint NetworkManager et rollback automatique.',
    remove: 'Retirer',
    opError: "L'opération réseau a été refusée"
  }
}
